declare namespace $ {

	export class $mol_icon_square extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=square.view.tree.d.ts.map